export let props = ['dialogVisible', 'title', 'exportType'];
export let model = {

}
export let computed = {
  _dialogVisible: {
    get() {
      return this.dialogVisible;
    },
    set(val) {
      this.$emit('update:dialogVisible', val);
    }
  },
  _exportType: {
    get() {
      return this.exportType;
    },
    set(v) {
      this.$emit('update:exportType', v);
    }
  }
};
